import Vue from 'vue'
import VueMoment from 'vue-moment'
import moment from 'moment/src/moment'

Vue.use(VueMoment, { moment });
